import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getSchoolAwayDetailList: (state) => state.items,
  getSchoolAwayDetailListPagination: (state) => state.pagination,
  getSchoolAwayDetailListPage: (state) => state.pagination.current_page,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
